import React from 'react';
import { Link } from 'react-router-dom';
import Tabs, { Tab, TabList, TabPanel } from '@atlaskit/tabs';

import LargeSlos from '@/components/composed/slos/large-slos';
import RevisionLogs from '@/components/primitive/revision-logs';
import { textDecorationNone, displayInlineBlock } from '@/styles';

import { PageContentProps } from './types';
import { CapabilityTabNames } from './constants';

const PageContent: React.FC<PageContentProps> = ({ id, tabName }) => {
  let selectedIndex: number;
  switch (tabName) {
    case CapabilityTabNames.SLO:
      selectedIndex = 0;
      break;
    case CapabilityTabNames.HISTORY:
      selectedIndex = 1;
      break;
    default:
      selectedIndex = 0;
  }

  return (
    <Tabs selected={selectedIndex} id="page-content-tabs">
      <TabList>
        <Tab>
          <Link relative="path" to={`/capability/${id}`} css={textDecorationNone}>
            <h4 css={displayInlineBlock}>SLOs</h4>
          </Link>
        </Tab>
        <Tab>
          <Link relative="path" to={`/capability/${id}/history`} css={textDecorationNone}>
            <h4 css={displayInlineBlock}>Change History</h4>
          </Link>
        </Tab>
      </TabList>
      <TabPanel>{id && <LargeSlos id={id} />}</TabPanel>
      <TabPanel>{id && <RevisionLogs entityType="capability" publicId={id} />}</TabPanel>
    </Tabs>
  );
};

export default PageContent;
